import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { NotificationDTO } from '@shared/schemas/notifications'
import { api } from './api'

const KEY = ['notifications'] as const

export function useNotifications() {
  return useQuery({
    queryKey: KEY,
    queryFn: () => api<{ notifications: NotificationDTO[] }>('/api/notifications').then((r) => r.notifications),
    refetchInterval: 30_000,
  })
}

export function useMarkNotificationRead() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => api('/api/notifications/read', { method: 'POST', body: JSON.stringify({ id }) }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  })
}

export function useMarkAllNotificationsRead() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => api('/api/notifications/read', { method: 'POST', body: JSON.stringify({ all: true }) }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  })
}
